import { FC, useMemo } from 'react';
import ContractForm from '../components/ContractForm';
import styles from './styles.module.css';
import { useNavigate, useParams } from 'react-router-dom';
import {
  createPostContractRequestFromFormData,
  useCreateContractMutation,
  useGetCollectionConstraintTypesQuery,
  useGetContractDetailQuery,
} from '../../../api/contractApi';
import { transformContractDetailToFormData } from '../../../types/contracts';
import { generateFormData } from '../generateFormData';
import HeaderLayout from '../../../components/HeaderLayout';
import { logger } from '../../../services/logger';
import { useGetWasteItemsQuery } from '../../../api/otherApi';
import { useGetDriverSkillLevelsQuery } from '../../../api/driverApi';
import { useGetCurrentUserQuery } from '../../../api/userApi';

const CopyContract: FC = () => {
  const { id } = useParams();
  const numId = Number(id);
  const { data: wasteItems } = useGetWasteItemsQuery();
  const { data: constraintTypes } = useGetCollectionConstraintTypesQuery();
  const { data: skillLevels } = useGetDriverSkillLevelsQuery();
  const { data: currentUser } = useGetCurrentUserQuery();
  const [create] = useCreateContractMutation();
  const navigate = useNavigate();
  const { data: formDetail } = useGetContractDetailQuery(numId);
  const formData = useMemo(() => {
    if (!formDetail) {
      return null;
    }
    const transformedFormDetail = transformContractDetailToFormData(formDetail);

    return {
      ...generateFormData({
        wasteItems,
        constraintTypes,
        skillLevels,
        currentUser,
      }),
      receivedAt: transformedFormDetail.receivedAt,
      salesPic: transformedFormDetail.salesPic,
      contractDocumentTypeId: transformedFormDetail.contractDocumentTypeId,
      supplierCompanyInfo: transformedFormDetail.supplierCompanyInfo,
      contractorCompanyInfo: transformedFormDetail.contractorCompanyInfo,
      wastePointCompanyInfo: transformedFormDetail.wastePointCompanyInfo,
      wastePointCompanyIsTheSameSupplier:
        transformedFormDetail.wastePointCompanyIsTheSameSupplier,
    };
  }, [formDetail, wasteItems]);

  return (
    <HeaderLayout
      title={
        <>
          受注入力
          {formDetail && (
            <span
              className={styles.subtitle}
            >{`(No.${formDetail.contractId}の複製)`}</span>
          )}
        </>
      }
    >
      {formData && (
        <ContractForm
          initState={formData}
          wasteItems={wasteItems}
          constraintTypes={constraintTypes}
          skillLevels={skillLevels}
          onSubmit={(data) => {
            create(createPostContractRequestFromFormData(data))
              .unwrap()
              .then(() => {
                navigate('/contracts');
              })
              .catch(logger.error);
          }}
          onCancel={() => {
            navigate('/contracts');
          }}
        />
      )}
    </HeaderLayout>
  );
};

export default CopyContract;
